module.exports = __webpack_public_path__ + "img/BD.e9cdff26.svg";